var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 16,
    viewBox: "0 0 231 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 230.857,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_49",
    transform: "scale(0.00740741 0.111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_49",
    width: 135,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAAAJCAYAAAAYXT+iAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAh6ADAAQAAAABAAAACQAAAADU6qrfAAABT0lEQVRYCe1WMW7DMAykHAcokgAB8oMCnbr0BZn7kz4gD8qQT2TJA7r2C167dKnjBpEd0RJtKqWgji5ALaRJHmkfLJIG3Pm8HjuUTVeh6I81P6RCC14niQ5Jb+EyYkwz6sEuYZK5hPo8NqoFQq0MHnN1YFFM9tR2NbxbbZe9fg4SH76Zn9vr1sdyfOQPOVL+xuU9Pe1MQT/G8BaqKAOOgbfq8FHmugUyRTeeJLd53XeMVugWPDaNZ10q3Ph0bKgldIu+Vgb/H7sFfhfd/Fy3wFjqCITxNt9N/uI/24Wr9wAFButRBiQG9OeQWFFbz0C5LJ4HKr6690GX2nps+718xksiGxW5hVZYHpO1wjiJamXwUx8lSDqNAlo80cbHAo0TbqPFk+M5juei/Ck/zzuHDcxhrWMFydIjM6BjReZFrY6BYjPbGmVCGbhnYP/4+nIDygDhW6Pl8NAAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.a32a5d1797c3fe7f2a2942b11a01c7da.svg";
export { ForwardRef as ReactComponent };